import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Slider from 'rc-slider';
import i18n from 'i18n-react';


import Toast from 'components/Toast';
import StorageHandler from 'config/StorageHandler';
import { storageKeys } from 'config/settings.json';

import 'rc-slider/assets/index.css';

export default class TrainingSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      answerFeedback: '',
      toastContent: null,
      headerImage: '',
      currentValue: null,
      answeredCorrectly: false,
    };
  }

  componentDidMount() {
    this.setHeader();
  }

  componentDidUpdate(prevProps) {
    const { quizMode, quizTimerExpired, error } = this.props;
    if (quizMode && quizTimerExpired && !prevProps.quizTimerExpired) {
      setTimeout(() => error(true), 600);
    }
  }

  async setHeader() {
    // Load profile image image
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    const { questionHeader } = appInfo;
    this.setState({ headerImage: questionHeader });
  }

  render() {
    const {
      contentComplete,
      correctAnswer,
      correctAnswerText,
      disableHeader,
      disableToast,
      endNumber,
      error,
      incorrectAnswerText,
      question,
      startNumber,
      steps,
      completedBefore,
      quizMode,
    } = this.props;

    const marks = {};
    const noSteps = steps.every((step) => +step === 0);
    if (noSteps) {
      steps.forEach((step, index) => {
        marks[Math.round(+endNumber / (steps.length - 1)) * index] =
          Math.round(+endNumber / (steps.length - 1)) * index;
      });
    } else {
      steps.forEach((step, index) => {
        if (step !== null) {
          marks[step] = steps[index];
          // marks[Math.round(+endNumber / (steps.length - 1)) * index] =
          //   steps[index];
        }
      });
    }

    const { answerFeedback, toastContent, headerImage, currentValue, answeredCorrectly } = this.state;

    // Determine the slider value that corresponds to the correct answer
    let correctValueKey = null;
    Object.keys(marks).forEach((k) => {
      if (+marks[k] === +correctAnswer) correctValueKey = +k;
    });
    if (correctValueKey === null) {
      correctValueKey = +correctAnswer;
    }

    return (
      <div
        className={clsx('container__question', { 'quiz-mode-card': quizMode })}
        style={{
          pointerEvents: completedBefore || answeredCorrectly ? 'none' : 'auto',
        }}
      >
        {!disableHeader && (
          <div className="container__question--image" style={{ backgroundImage: `url(${headerImage})` }} />
        )}
        <div className="container__question--content trainingSlider">
          <h4 className="container__title">{question}</h4>
          <div className="slider__container">
            <Slider
              className={clsx('questionSlider', completedBefore || answeredCorrectly ? 'correct' : answerFeedback)}
              min={+startNumber}
              max={+endNumber}
              step={null} // NOTE: Slider's step property needs to be null and cannot be left empty
              marks={marks || null}
              value={
                completedBefore || answeredCorrectly
                  ? correctValueKey
                  : currentValue !== null
                    ? currentValue
                    : undefined
              }
              onChange={(value) => {
                if (completedBefore || answeredCorrectly) return;
                this.setState({ currentValue: value });
              }}
            />
          </div>
          {!completedBefore && !answeredCorrectly && (
            <button
              type="button"
              className="slider__submit-button"
              onClick={() => {
                if (currentValue === null) return;

                const answerValue = marks && marks[currentValue] !== undefined ? +marks[currentValue] : +currentValue;

                if (answerValue === +correctAnswer) {
                  this.setState({
                    answerFeedback: 'correct',
                    answeredCorrectly: true,
                    toastContent: {
                      content: correctAnswerText,
                      position: 'top-center',
                    },
                  });
                  contentComplete();
                } else {
                  this.setState({
                    answerFeedback: 'incorrect',
                  });
                  error(true);
                }
              }}
              disabled={currentValue === null}
            >
              {i18n.translate('general.submit')}
            </button>
          )}
          {!disableToast && (
            <Toast
              trigger={toastContent !== null}
              onOpen={() => {
                this.setState({ toastContent: null });
              }}
              {...toastContent}
            />
          )}
          {error(false)}
        </div>
      </div>
    );
  }
}

TrainingSlider.propTypes = {
  contentComplete: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  disableToast: PropTypes.bool,
  endNumber: PropTypes.string.isRequired,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
  startNumber: PropTypes.string,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  completedBefore: PropTypes.bool,
  quizMode: PropTypes.bool,
  quizTimerExpired: PropTypes.bool,
};

TrainingSlider.defaultProps = {
  correctAnswerText: '',
  disableHeader: false,
  disableToast: false,
  error: () => {},
  incorrectAnswerText: '',
  startNumber: 0,
  completedBefore: false,
  quizMode: false,
  quizTimerExpired: false,
};
